export default __webpack_public_path__ + "static/media/icon-smart-vision.5dacf9d8.svg";